<template>
  <div>
    <van-nav-bar
      :fixed="true"
      left-text="返回"
      left-arrow
      title="客人档案"
      right-text="保存档案"
      @click-left="historyBack()"
      @click-right="addCustHeadInfo()"
    />
    <van-cell-group style="margin-top: 35px">
      <van-cell>
        <van-row>
          <van-col span="12">贵宾姓名:{{custheadinfo.membername}}</van-col>
          <van-col span="12">性别:<span v-if="custheadinfo.sex==1">男</span><span v-else>女</span></van-col>
        </van-row>
        <van-row>
          <van-col span="12">贵宾卡号:{{custheadinfo.cardnumber}}</van-col>
          <van-col span="12">贵宾级别:{{custheadinfo.cardtypename}}</van-col>
        </van-row>
        <van-row>
          <van-col span="12">生日:{{$moment(custheadinfo.birthday).format("YYYY-MM-DD")}}</van-col>
          <van-col span="12">微信号:{{custheadinfo.wechat}}</van-col>
        </van-row>
        <van-row>
          <van-col span="24">是否美容客户:{{custheadinfo.beatuy}}</van-col>
        </van-row>
        <van-row>
          <van-col span="8">洗发场所:</van-col>
          <van-col span="16">
            <van-radio-group v-model="custheadinfo.xfcs">
              <van-row gutter="20" >
                <van-col span="12"><van-radio :name="1">居家居多</van-radio></van-col>
                <van-col span="12"><van-radio :name="2">发廊居多</van-radio></van-col>
              </van-row>
            </van-radio-group>
          </van-col>
        </van-row>
      </van-cell>
      <van-cell>
        <van-row>
          <van-col span="8" class="head">喜欢的发型:</van-col>
          <van-checkbox-group v-model="custheadinfo.likefx">
            <van-row gutter="20" >
              <van-col  class="rows"><van-checkbox name="1">长发</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="2">中发</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="3">短发</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="4">bob</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="5">卷发</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="6">颜色</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="7">多色</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="8">日系</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="9">沙宣式</van-checkbox></van-col>
            </van-row>
          </van-checkbox-group>
        </van-row>
      </van-cell>
      <van-cell>
        <van-row>
          <van-col span="8" class="head">不喜欢的发型:</van-col>
          <van-checkbox-group v-model="custheadinfo.notfx">
            <van-row gutter="20" >
              <van-col class="rows"><van-checkbox name="1">长发</van-checkbox></van-col>
              <van-col class="rows"><van-checkbox name="2">中发</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="3">短发</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="4">bob</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="5">卷发</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="6">颜色</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="7">多色</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="8">日系</van-checkbox></van-col>
              <van-col  class="rows"><van-checkbox name="9">沙宣式</van-checkbox></van-col>
            </van-row>
          </van-checkbox-group>

        </van-row>
      </van-cell>
      <!--<van-cell>
          <van-col span="6" class="head">喜欢的水果:</van-col>
          <van-checkbox-group v-model="result">
              <van-row gutter="20" >
                  <van-col class="rows"><van-checkbox name="1">西瓜</van-checkbox></van-col>
                  <van-col class="rows"><van-checkbox name="2">西红柿</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="3">橙子</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="4">冬枣</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="5">黄瓜</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="6">哈密瓜</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="7">桔子</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="8">樱桃</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="9">柿子</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="10">葡萄</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="11">山竹</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="12">火龙果</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="13">龙眼</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="14">桂圆</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="15">荔枝</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="16">苹果</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="17">芒果</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="18">提子</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="19">香蕉</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="20">金桔</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="21">猕猴桃</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="22">无花果</van-checkbox></van-col>
                  <van-col class="rows"><van-checkbox name="23">桃子</van-checkbox></van-col>
                  <van-col class="rows"><van-checkbox name="24">蓝莓</van-checkbox></van-col>
                  <van-col  class="rows"><van-checkbox name="25">草莓</van-checkbox></van-col>
              </van-row>
          </van-checkbox-group>
      </van-cell>-->
      <div style="font-size: 10px;color: #c0c4cc;text-align: left;margin-top: 5px;"></div>
      <van-cell>
        <van-row>
          <van-col span="12">
            <van-field
              readonly
              clickable
              label="烫发周期"
              :value="custheadinfo.tfzqname"
              placeholder="烫发周期"
              @click="showPicker = true"
            />
          </van-col>
          <van-col span="12">
            <van-field
              readonly
              clickable
              label="染发周期"
              :value="custheadinfo.rfzqname"
              placeholder="染发周期"
              @click="showPickerRf = true"
            />
          </van-col>
        </van-row>
      </van-cell>
      <van-cell>
        <van-row>
          <van-col span="8" class="head">头发健康状况</van-col>
          <van-col span="16">
            <van-checkbox-group v-model="custheadinfo.tfjkzk">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-checkbox name="1">干燥</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="2">断裂</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="3">干枯分叉</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="4">烫染损伤</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="5">白发</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="6">斑秃</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="7">脱发</van-checkbox></van-col>
              </van-row>
            </van-checkbox-group>
          </van-col>
        </van-row>
      </van-cell>

      <van-cell>
        <van-row>
          <van-col span="24" class="head">头部健康状况</van-col>
          <van-col span="12">颈椎病:</van-col>
          <van-col span="12">
            <van-radio-group v-model="custheadinfo.jzb">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-radio name="1">重度</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="2">轻度</van-radio></van-col>
              </van-row>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">头部经络:</van-col>
          <van-col span="12">
            <van-radio-group v-model="custheadinfo.tbjl">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-radio name="1">一般</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="2">轻度</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="3">严重</van-radio></van-col>
              </van-row>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">脑供血不足:</van-col>
          <van-col span="12">
            <van-radio-group v-model="custheadinfo.lgxbz">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-radio name="1">是</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="2">否</van-radio></van-col>
              </van-row>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">有无得过脑梗:</van-col>
          <van-col span="12">
            <van-radio-group v-model="custheadinfo.glg">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-radio name="1">是</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="2">否</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="3">家族</van-radio></van-col>
              </van-row>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">油脂分泌:</van-col>
          <van-col span="12">
            <van-radio-group v-model="custheadinfo.yzfm">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-radio name="1">过油</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="2">过干</van-radio></van-col>
              </van-row>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">毛囊萎缩:</van-col>
          <van-col span="12">
            <van-radio-group v-model="custheadinfo.mlws">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-radio name="1">重度</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="2">轻度</van-radio></van-col>
              </van-row>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">毛囊口油脂堵塞:</van-col>
          <van-col span="12">
            <van-radio-group v-model="custheadinfo.mlkyzds">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-radio name="1">重度</van-radio></van-col>
                <van-col span="12" class="rows"><van-radio name="2">轻度</van-radio></van-col>
              </van-row>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">头皮敏感:</van-col>
          <van-col span="12">
            <van-checkbox-group v-model="custheadinfo.tpmg">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-checkbox name="1">发红</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="2">痒</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="3">发白</van-checkbox></van-col>
              </van-row>
            </van-checkbox-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">头皮炎症:</van-col>
          <van-col span="12">
            <van-checkbox-group v-model="custheadinfo.tpyz">
              <van-row gutter="20" >
                <van-col span="12" class="rows"><van-checkbox name="1">丘疹</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="2">脓包</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="3">毛囊肿</van-checkbox></van-col>
                <van-col span="12" class="rows"><van-checkbox name="4">暗疮</van-checkbox></van-col>
              </van-row>
            </van-checkbox-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-col span="8">头皮屑:</van-col>

            <van-checkbox-group v-model="custheadinfo.tpx">
              <van-row gutter="20" >
                <van-col class="rows"><van-checkbox name="1">重度</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="2">轻度</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="3">头皮癣</van-checkbox></van-col>
              </van-row>
            </van-checkbox-group>
          </van-col>
        </van-row>
      </van-cell>
      <van-cell>
        <van-row>
          <van-col span="24">
            <van-col span="8" class="head">神经健康状况</van-col>
            <van-checkbox-group v-model="custheadinfo.sjjkzk">
              <van-row gutter="20" >
                <van-col  class="rows"><van-checkbox name="1">头晕</van-checkbox></van-col>
                <van-col class="rows"><van-checkbox name="2">失眠</van-checkbox></van-col>
                <van-col class="rows"><van-checkbox name="3">乏力</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="4">恶心</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="5">偏头痛</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="6">烦躁不安</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="7">发脾气</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="8">易感冒</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="9">头皮紧绷</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="10">神经衰弱</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="11">腰痛</van-checkbox></van-col>
                <van-col  class="rows"><van-checkbox name="12">记忆力下降</van-checkbox></van-col>
              </van-row>
            </van-checkbox-group>
          </van-col>
        </van-row>
      </van-cell>
      <van-cell>
        <van-row>
          <van-col span="3" class="head">诊断</van-col>
          <van-checkbox-group v-model="custheadinfo.zd">
            <van-row gutter="20" >
              <van-col class="rows"><van-checkbox name="1">头部亚健康</van-checkbox></van-col>
              <van-col class="rows"><van-checkbox name="2">神经亚健康</van-checkbox></van-col>
              <van-col class="rows"><van-checkbox name="3">经络亚健康</van-checkbox></van-col>
              <van-col class="rows"><van-checkbox name="4">头皮亚健康</van-checkbox></van-col>
            </van-row>
          </van-checkbox-group>

        </van-row>
        <van-cell-group style="margin-top: 10px;border: 0px" class="group">
          <van-field v-model="custheadinfo.zjzd" label="专家诊断" :border="true" />
        </van-cell-group>
      </van-cell>
    </van-cell-group>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="showPickerRf" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPickerRf = false"
        @confirm="onConfirmRf"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      custheadinfo:{

      },
      showPicker:false,
      columns:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],
      values:[1,2,3,4,5,6,7,8,9,10,11,12],
      cardid:"",
      showPickerRf:false,
    }
  },
  created:function () {
    /*dd.biz.navigation.setTitle({
        title : '客户档案',//控制标题文本，空字符串表示显示默认文本
    });
    let that=this;
    dd.biz.navigation.setRight({
        show: true,//控制按钮显示， true 显示， false 隐藏， 默认true
        control: true,//是否控制点击事件，true 控制，false 不控制， 默认false
        text: '保存档案',//控制显示文本，空字符串表示显示默认文本
        onSuccess : function(result) {
            that.addCustHeadInfo();
        },
    });*/
    this.cardid=this.$route.query.cardid;
    this.getCustHeadInfoById();
  },
  methods:{
    addCustHeadInfo(){
      if (this.custheadinfo.likefx.length>0) {
        this.custheadinfo.likefx = this.custheadinfo.likefx.join(",");
      }
      else {
        this.custheadinfo.likefx = "";
      }
      if (this.custheadinfo.notfx.length>0) {
        this.custheadinfo.notfx = this.custheadinfo.notfx.join(",");
      }
      else {
        this.custheadinfo.notfx = "";
      }
      if (this.custheadinfo.tfjkzk.length>0) {
        this.custheadinfo.tfjkzk = this.custheadinfo.tfjkzk.join(",");
      }
      else {
        this.custheadinfo.tfjkzk = "";
      }

      if (this.custheadinfo.tpmg.length>0) {
        this.custheadinfo.tpmg = this.custheadinfo.tpmg.join(",");
      }
      else {
        this.custheadinfo.tpmg = "";
      }

      if (this.custheadinfo.tpyz.length>0) {
        this.custheadinfo.tpyz = this.custheadinfo.tpyz.join(",");
      }
      else {
        this.custheadinfo.tpyz = "";
      }

      if (this.custheadinfo.tpx.length>0) {
        this.custheadinfo.tpx = this.custheadinfo.tpx.join(",");
      }
      else {
        this.custheadinfo.tpx = "";
      }

      if (this.custheadinfo.sjjkzk.length>0) {
        this.custheadinfo.sjjkzk = this.custheadinfo.sjjkzk.join(",");
      }
      else {
        this.custheadinfo.sjjkzk = "";
      }

      if (this.custheadinfo.zd.length>0) {
        this.custheadinfo.zd = this.custheadinfo.zd.join(",");
      }
      else {
        this.custheadinfo.zd = "";
      }
      this.$postw("/ddstaff/addCustHeadInfo",this.custheadinfo).then((res)=>{
        if(res.sucess){
          this.$toast('保存成功');
          this.$router.back(-1);
        }
        else{
          this.setArray();
          this.$dialog.alert({
            title: "提示",
            message: res.message
          });
        }
      })
    },
    onConfirmRf(value,idx){
      this.custheadinfo.rfzqname=value;
      this.custheadinfo.rfzq=this.values[idx];
      this.showPickerRf=false;
    },
    onConfirm(value,idx){
      this.custheadinfo.tfzqname=value;
      this.custheadinfo.tfzq=this.values[idx];
      this.showPicker=false;
    },
    setArray() {
      if (!this.custheadinfo.xfcs) {
        this.custheadinfo.xfcs = "";
      }
      if (!this.custheadinfo.jzb) {
        this.custheadinfo.jzb = "";
      }
      if (!this.custheadinfo.lgxbz) {
        this.custheadinfo.lgxbz = "";
      }
      if (!this.custheadinfo.glg) {
        this.custheadinfo.glg = "";
      }
      if (!this.custheadinfo.yzfm) {
        this.custheadinfo.yzfm = "";
      }

      if (!this.custheadinfo.mlws) {
        this.custheadinfo.mlws = "";
      }

      if (!this.custheadinfo.mlkyzds) {
        this.custheadinfo.mlkyzds = "";
      }

      if(!this.custheadinfo.tbjl){
        this.custheadinfo.tbjl="";
      }

      if (this.custheadinfo.likefx) {
        this.custheadinfo.likefx = this.custheadinfo.likefx.split(",");
      }
      else {
        this.custheadinfo.likefx = [];
      }
      if (this.custheadinfo.notfx) {
        this.custheadinfo.notfx = this.custheadinfo.notfx.split(",");
      }
      else {
        this.custheadinfo.notfx = [];
      }
      if (this.custheadinfo.tfjkzk) {
        this.custheadinfo.tfjkzk = this.custheadinfo.tfjkzk.split(",");
      }
      else {
        this.custheadinfo.tfjkzk = [];
      }

      if (this.custheadinfo.tpmg) {
        this.custheadinfo.tpmg = this.custheadinfo.tpmg.split(",");
      }
      else {
        this.custheadinfo.tpmg = [];
      }

      if (this.custheadinfo.tpyz) {
        this.custheadinfo.tpyz = this.custheadinfo.tpyz.split(",");
      }
      else {
        this.custheadinfo.tpyz = [];
      }

      if (this.custheadinfo.tpx) {
        this.custheadinfo.tpx = this.custheadinfo.tpx.split(",");
      }
      else {
        this.custheadinfo.tpx = [];
      }

      if (this.custheadinfo.sjjkzk) {
        this.custheadinfo.sjjkzk = this.custheadinfo.sjjkzk.split(",");
      }
      else {
        this.custheadinfo.sjjkzk = [];
      }

      if (this.custheadinfo.zd) {
        this.custheadinfo.zd = this.custheadinfo.zd.split(",");
      }
      else {
        this.custheadinfo.zd = [];
      }
    },
    getCustHeadInfoById(){
      this.$post("/ddstaff/getCustHeadInfoById",{cardid:this.cardid}).then((res)=> {
        if (res.sucess) {
          this.custheadinfo = res.object;
          this.setArray();
        }
        else{
          this.$message.error(res.message);
        }
      });
    },
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.mycustpage{
  padding: 1rem;
  padding-bottom: 30px;
  font-size: 14px;
  background-color: #f1f1f1;
}
.rows{
  margin-bottom: 10px;
}

.head{
  font-size: 16px;
  font-weight:800;
}
</style>



// WEBPACK FOOTER //
// src/page/hair/haircustfiles.vue